/* Progress bar dopravy zdarma na PDP. Progresivni: pocita kosik + prave
   vybrane baleni (event pkgpick:change z package-pickeru, jinak data-extra).
   Kosik zivy z /cart.js pri kazdem nacteni + pubsub cartUpdate. Guard flag. */
(function () {
  if (window.__yerbShipProgress) return;
  window.__yerbShipProgress = true;

  var els = document.querySelectorAll('[data-shipping-progress]');
  if (!els.length) return;

  var cartKc = null;
  var extraKc = null;

  function fmt(n) {
    return Math.round(n).toLocaleString('cs-CZ');
  }

  function render(el) {
    var threshold = parseFloat(el.dataset.threshold) || 0;
    var label = el.querySelector('[data-label]');
    var fill = el.querySelector('[data-fill]');
    if (!threshold || !label || !fill) return;
    var cart = cartKc === null ? (parseFloat(el.dataset.total) || 0) : cartKc;
    var extra = extraKc === null ? (parseFloat(el.dataset.extra) || 0) : extraKc;
    var total = cart + extra;
    fill.style.width = Math.min(total / threshold * 100, 100) + '%';
    el.classList.toggle('is-done', total >= threshold);
    if (cart >= threshold) {
      label.textContent = 'Máš dopravu zdarma · v košíku ' + fmt(cart) + ' Kč';
    } else if (total >= threshold) {
      label.textContent = 'S tímhle nákupem máš dopravu zdarma';
    } else if (total > 0) {
      label.textContent = 'Do dopravy zdarma zbývá ' + fmt(threshold - total) + ' Kč';
    } else {
      label.textContent = 'Doprava zdarma od ' + fmt(threshold) + ' Kč';
    }
  }

  function renderAll() {
    els.forEach(render);
  }

  renderAll();

  function refresh() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartKc = cart.total_price / 100; renderAll(); })
      .catch(function () {});
  }

  // serverovy stav muze byt nakesovany - VZDY po nacteni prepsat zivym stavem kosiku
  refresh();

  // zmena vyberu baleni v pickeru
  document.addEventListener('pkgpick:change', function (e) {
    var p = parseFloat(e.detail && e.detail.price);
    if (!isNaN(p)) { extraKc = p; renderAll(); }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  window.addEventListener('pageshow', function () {
    refresh();
  });
})();
